import React from "react";
import { Button, Card, CardActions, CardContent, Typography, Box, Stack } from "@mui/material";
import { red, amber, green } from "../../shared/colours";
import { ThumbUp, Warning } from "@mui/icons-material";
import { truncateSentence } from "../../shared/sharedFunctions";

const RiskCard = (props) => {
	
	const handleClick = () => {
		props.onReadMore(props.risk);
	}
	
	let headerBackground = red;
	if (props.risk && props.risk.severity === 1) headerBackground = amber;
	if (props.risk && props.risk.severity === 0) headerBackground = green;
	
	let headerColor = "";
	let headerTitle = "";
	if (props.risk && props.risk.severity === 2) {
		headerColor = red;
		headerTitle = "High Risk";
	}
	if (props.risk && props.risk.severity === 1) {
		headerColor = amber;
		headerTitle = "Medium Risk";
	}
	if (props.risk && props.risk.severity === 0) {
		headerColor = green;
		headerTitle = "Low Risk";
	}
	
	return (
		<React.Fragment>
		{(props.risk)?
			<Card
				sx={{
					flexGrow: 1,
					border: "1px solid",
					borderRadius: "1em",
					borderColor: "text.primary",
					position: "relative",
					height: "100%",
					minWidth: props.width,
					maxWidth: props.width,
					backgroundColor: "background.card",
					boxShadow: "none"
				}}
			>
				<CardContent>
					<Box sx={{
						background: headerBackground,
						borderRadius: "1em",
						padding: "0.5em",
						textAlign: "center",
						fontWeight: "bold",
						color: "#fff"
					}}>
						{/* <Box sx={{ position: "absolute", top: "2em", left: "1.5em"}}>
							{headerBackground === green? <ThumbUp/> : <Warning/>}
						</Box> */}
						<Typography sx={{ fontWeight: "bold", fontSize: "1.25em" }}>{headerTitle}</Typography>
						<Typography sx={{ fontSize: "0.85em" }}>{props.risk.title}</Typography>
					</Box>
					<Stack direction="row" sx={{
						backgroundColor: "background.category",
						borderRadius: "1em",
						padding: "0.25em 0 0.25em 1.25em",
						margin: "0.5em 0"
					}}>
						{headerColor === green?
							<ThumbUp sx={{ marginTop: "0.1em" }}/> : <Warning sx={{ marginTop: "0.1em" }}/>
						}
						<Typography sx={{
							lineHeight: "1.2em",
							fontSize: "1em",
							margin: "0.2em 0.5em"
						}}>
							{props.risk.category}
						</Typography>
					</Stack>
					<Typography sx={{ minHeight: "5.75em", maxHeight: "5.75em" }}>
						{(props.risk.description_short.length > 99)?
							`${truncateSentence(props.risk.description_short, 99)} ...` : props.risk.description_short
						}
					</Typography>
				</CardContent>
				<CardActions>
					<Button onClick={handleClick} size="small" sx={{ fontWeight: "bold", fontSize: "1em" }}>
						Read More
					</Button>
				</CardActions>
			</Card>
		: <React.Fragment/> }
		</React.Fragment>
	);
	
};

export default RiskCard;